import { useState } from 'react';

export type Theme = 'dark' | 'light';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    const saved = (localStorage.getItem('wealthos-theme') as Theme) ?? 'dark';
    // Apply eagerly — prevents flash on first render
    document.documentElement.classList.toggle('dark', saved === 'dark');
    return saved;
  });

  const toggle = () => {
    setTheme(prev => {
      const next: Theme = prev === 'dark' ? 'light' : 'dark';
      document.documentElement.classList.toggle('dark', next === 'dark');
      localStorage.setItem('wealthos-theme', next);
      return next;
    });
  };

  return { theme, toggle, isDark: theme === 'dark' };
}
